import { render, staticRenderFns } from "./SelectLanguage.vue?vue&type=template&id=52343a9f&scoped=true&"
import script from "./SelectLanguage.vue?vue&type=script&lang=js&"
export * from "./SelectLanguage.vue?vue&type=script&lang=js&"
import style0 from "./SelectLanguage.vue?vue&type=style&index=0&id=52343a9f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52343a9f",
  null
  
)

export default component.exports